// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import VueTheMask from 'vue-the-mask'
import 'normalize.css'
import './assets/fonts.css'
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css'
import './bem.css'
import FormMain from './components/Form/FormMain'
import AppFormSuccess from './components/Form/AppFormSuccess'
import AppGallery from './components/Slider/AppGallery'
import AppSlider from './components/Slider/AppSlider'
import AppFormPopupPhone from './components/Form/AppFormPopupPhone'
import form from './store/form'
import slider from './store/slider'
import MenuPopupSub from './assets/js/Menu/MenuPopupSub'
import HeaderPopup from './assets/js/Popup/HeaderPopup'

// Подключаем глобально jQuery
window.$ = window.jQuery = require('jquery')

// Подключаем fancybox
require('@fancyapps/fancybox')

Vue.config.productionTip = false
Vue.use(Vuelidate)
Vue.use(VueTheMask)

/* eslint-disable no-new */
$(document).ready(function () {
  // Слайдеры
  if ($('#rbc-slider').length > 0) {
    new Vue({
      el: '#rbc-slider',
      store: slider,
      components: { AppSlider },
      template: '<AppSlider />'
    })
  }
  if ($('#rbc-form-popup-phone').length > 0) {
    new Vue({
      el: '#rbc-form-popup-phone',
      store: form,
      components: { AppFormPopupPhone },
      template: '<AppFormPopupPhone />'
    })
  }
  if ($('#rbc-form-success').length > 0) {
    new Vue({
      el: '#rbc-form-success',
      store: form,
      components: { AppFormSuccess },
      template: '<AppFormSuccess />'
    })
  }
  if ($('#rbc-slider-gallery').length > 0) {
    new Vue({
      el: '#rbc-slider-gallery',
      store: slider,
      components: { AppGallery },
      template: '<AppGallery />'
    })
  }
  // Формы
  if ($('#rbc-form-main').length > 0) {
    new Vue({
      el: '#rbc-form-main',
      store: form,
      components: { FormMain },
      template: '<FormMain />'
    })
  }
  new MenuPopupSub()
  new HeaderPopup()
})



// WEBPACK FOOTER //
// ./src/main.js